/**
 * Delivery the shop charges - the backend prices orders with the same numbers
 * (order.delivery-fee / order.free-delivery-threshold), so change both together.
 */
export const DELIVERY_EXPENSES = 170;
export const FREE_DELIVERY_THRESHOLD = 1500;

/** Courier delivery time in working days - the same as in the order confirmation email. */
export const DELIVERY_DAYS_MIN = 2;
export const DELIVERY_DAYS_MAX = 7;
export const DELIVERY_TIME_TEXT = `${DELIVERY_DAYS_MIN}–${DELIVERY_DAYS_MAX} работни дена`;
